<style>
#canvas {}
</style>
<template>
    <div v-if="!saved">
        <v-container class="mt-10 pt-5">
            <!-- Title section -->

            <!-- Duplicar o container para cada bloco  -->
            <v-container>
                <v-card elevation="8">
                    <!--card title-->
                    <v-card-title class="pb-0">
                        <v-container>
                            <span class="list-labels">Assine no quadrado abaixo</span>
                        </v-container>
                    </v-card-title>

                    <!--card content-->
                    <v-card-text class="py-0">
                        <v-container>
                            <v-row>
                                <!-- avatar ###################################### -->
                                <canvas id="canvas" :width="canvasWidth" :height="canvasHeight"
                                    style="margin-bottom: 20px; border: 1px solid darkcyan;"></canvas>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-container>
            <!-- Footer de submit para o formulario -->
            <v-footer fixed color="transparent" padless class="justify-center">
                <v-card elevation="6" class="pt-3 pb-4 px-4 footer-card">
                    <v-btn color="secondary" rounded large depressed class="px-12" @click="save()">Gravar</v-btn>
                </v-card>
            </v-footer>

        </v-container>
    </div>
    <div v-else>
        <v-container class="">
            <v-card elevation="8">
                <!--card title-->
                <v-card-title class="pb-0">
                    <v-container>
                        <span class="list-labels">Assinatura salva com sucesso!</span>
                    </v-container>
                </v-card-title>
                <!--card content-->
                <v-card-text class="py-0">
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-btn color="secondary" rounded large depressed @click="toBack()">
                                    <v-icon class="mr-3" color="white" small>fal fa-arrow-left</v-icon>Voltar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import EntityService from "@/scripts/services/entity.service";
export default {
    name: "New",
    inject: ["theme"],
    data: () => ({
        entityService: new EntityService(),
        id: '',
        canvasWidth: 400,
        canvasHeight: 200,
        canvas: null,
        saved: false
    }),
    methods: {
        load() {
            this.canvas = document.getElementById('canvas');
            var context = this.canvas.getContext('2d');

            var isDrawing = false;
            var lastX = 0;
            var lastY = 0;

            this.canvas.addEventListener('mousedown', function (e) {
                isDrawing = true;
                [lastX, lastY] = [e.offsetX, e.offsetY];
            });

            this.canvas.addEventListener('mousemove', function (e) {
                if (isDrawing) {
                    var x = e.offsetX;
                    var y = e.offsetY;

                    context.beginPath();
                    context.moveTo(lastX, lastY);
                    context.lineTo(x, y);
                    context.stroke();

                    [lastX, lastY] = [x, y];
                }
            });

            this.canvas.addEventListener('mouseup', function () {
                isDrawing = false;
            });

            this.canvas.addEventListener('mouseout', function () {
                isDrawing = false;
            });

            //document.getElementById('clearButton').addEventListener('click', function () {
            //    context.clearRect(0, 0, this.canvas.width, this.canvas.height);
            //    document.getElementById('signatureImage').src = "";
            //});

            //document.getElementById('saveButton').addEventListener('click', function () {
            //    var dataURL = this.canvas.toDataURL(); // Converte o desenho para uma imagem base64
            //    document.getElementById('signatureImage').src = dataURL;
            //});
        },
        save() {
            console.log("save click:" + this.canvas.toDataURL());
            this.entityService.saveSignatureCouncil(this.id, this.canvas.toDataURL()).then(()=>{
                this.saved=true;
            });
        },
        toBack() {
            this.$router.push('/')
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        console.log("this.id:", this.id);

        //console.log("window.innerWidth:", window.innerWidth);
        this.canvasWidth = window.innerWidth * 0.71;
        this.canvasHeight = window.innerHeight - 300;

        this.load();
    }
};
</script>